import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import './ModalUpdateEmailShoyo.scss';
import { loadDataList, saveData } from '../../../actions';

const editEmailShoyo = async (values) => {
    const { idBoxShoyo, partnerIdBoxShoyo, isPartner, id, email } = values;
    const response = await fetch(`/api/contracts/${id}/shoyo/box/updateEmailBoxShoyo`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            isPartner,
            idBoxShoyo,
            partnerIdBoxShoyo,
            email: email.trim(),
            ripId: id,
        }),
    });

    let body;
    const text = await response.text();
    try {
        body = JSON.parse(text);
    } catch (e) {
        body = text || {};
    }

    return { ok: response.ok, status: response.status, body };
};

const renderTextField = ({
    input,
    label,
    type,
    meta: { touched, error },
}) => (
    <div className="edit-email-input-container">
        <label htmlFor={input.name}>{label}</label>
        <div >
            <input {...input} id={input.name} type={type} />
            {touched && error && <span style={{ color: 'red' }}>{error}</span>}
        </div>
    </div>
);

const ModalUpdateEmailShoyo = ({ handleSubmit, pristine, submitting, reset, onCancel }) => {
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    const handleFormSubmit = async (values, dispatch) => {
        if (!values.email) {
            setMessage('Veuillez saisir un e-mail.');
            setMessageType('error');

            return;
        }

        setMessage('');
        setMessageType('');

        try {
            const responseIsEditInShoyo = await editEmailShoyo(values);

            if (responseIsEditInShoyo.ok) {
                setMessage("La modification a été réalisée avec succès. L'accès à l'eDoc se fera avec cette nouvelle adresse e-mail.");
                setMessageType('success');
                if (values.isPartner) {
                    dispatch(saveData('rip', values.id, { partnerPersonalEmail: values.email }));
                } else {
                    dispatch(saveData('rip', values.id, { personalEmail: values.email }));
                }
                dispatch(loadDataList('rip', { values }));
            } else if (400 === responseIsEditInShoyo.status && responseIsEditInShoyo.body && responseIsEditInShoyo.body.message) {
                // Affiche le message d'erreur spécifique de Shoyo
                setMessage(responseIsEditInShoyo.body.message);
                setMessageType('error');
            } else {
                setMessage("Une erreur s'est produite lors de la modification de l'e-mail.");
                setMessageType('error');
            }
        } catch (error) {
            setMessage("Une erreur s'est produite, veuillez nous excuser pour la gêne occasionnée.");
            setMessageType('error');
        }
    };

    return (
        <form onSubmit={handleSubmit(handleFormSubmit)} className="edit-email-form">
            <Field
                name="email"
                type="email"
                component={renderTextField}
                label="Saisir la nouvelle adresse e-mail"
                placeholder="adresse@email.com"
            />
            {!message && (<p className="edit-email-info">La mise à jour de l&apos;e-mail nécessite une vérification sur eDoc.</p>)}
            {message && (
                <div
                    className={`edit-email-message ${messageType}`}
                    style={{
                        color: (() => {
                            if ('success' === messageType) { return 'green'; }
                            if ('error' === messageType) { return 'red'; }

                            return 'orange';
                        })(),
                        textAlign: 'center',
                    }}
                >
                    {'success' === messageType ? (
                        <div>
                            {message}
                            <p style={{ textDecoration: 'underline' }}>Pensez à informer votre client.</p>
                        </div>
                    ) : (
                        message
                    )}
                </div>
            )}
            <div className="edit-email-submit-footer">
                <button
                    className="edit-email-submit-button"
                    type="submit"
                    disabled={pristine || submitting}
                    style={'success' === messageType ? { display: 'none' } : { display: 'block' }}
                >
                    Modifier
                </button>
                <button
                    className="edit-email-cancel-button"
                    type="button"
                    onClick={onCancel || reset}
                >
                    {'success' === messageType ? 'Fermer' : 'Annuler'}
                </button>
            </div>
        </form>
    );
};
ModalUpdateEmailShoyo.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    reset: PropTypes.func,
    onCancel: PropTypes.func,
};

export default reduxForm({
    form: 'updateEmailShoyo',
    enableReinitialize: true,
})(ModalUpdateEmailShoyo);
